document.addEventListener('BiscuitsBundleForm:ready', (e) => {
  /*
   * Setup shared Variables and elements
   */

  // Biscuits Bundle Elements
  const bundleForm = e.target;
  const bundleSteps = bundleForm.bundleSteps;

  // create a new obj that organizes the bundle steps into: includesGiftBox, assortments, and addOns
  const bundleStepCategories = categorizeBundleSteps();

  // Product Form Elements
  const productForm = bundleForm.productForms[0];
  const productSubmitBtn = bundleForm.submitButtons[0];
  const addToCartTextSpan = productSubmitBtn.querySelector('span');

  // Add to Cart Price Elements
  addToCartTextSpan.classList.add('product-form__submit-text');
  const addToCartPriceSpan = document.createElement('span');
  addToCartPriceSpan.classList.add('product-form__submit-price');

  /*
   * The following funciton invocations initialize all the logic for this file
   */
  prependStartingAtTextToPrice();
  handlePriceUpdates();
  appendAddonsToProductForm();
  arrangePdpActionArea();

  // PRC 12.2025: Add-On Selection Based on Selected Pack
  // PRC 01.2026: Make conditional on configurable template
  if (window.shopifyTemplate === 'product.configurable') {
    initDynamicMacoLink();
    initAddOnSelectionLogic(bundleForm, bundleStepCategories);
  }
  
  /*
   * Function definitions
   */

  // PRC 12.2025: Add-On Selection Based on Selected Pack
  function initAddOnSelectionLogic(bundleForm, bundleStepCategories) {
    let relatedSteps = [
      {
        parentStep: 1, 
        childStep: 2
      }
    ];

    toggleStepProducts([1]);
    linkConditionalProducts(relatedSteps);
  }

  // Helper function to get pack size from a product item's handle
  // Looks for 25, 50, or 100 in the product handle
  function getPackSizeFromProduct(productItem) {
    let handle = productItem.dataset.biscuitsHandle || '';
    
    // Check for pack sizes in order of specificity (100 first to avoid matching "10" in "100")
    if (handle.includes('100')) {
      return '100';
    } else if (handle.includes('50')) {
      return '50';
    } else if (handle.includes('25')) {
      return '25';
    }
    
    return null;
  }

  function toggleStepProducts(stepNumbers){
    if (!stepNumbers){
      return;
    }
    stepNumbers.forEach(function(stepNumber){
      let step = document.querySelector('[data-biscuits-step="'+ stepNumber+'"');

      if (step.dataset.biscuitsSelection != 's'){
        return;
      }
      let productItems = step.querySelectorAll('.biscuits-bundle-item');

      
      productItems.forEach(function(productItem){
        productItem.addEventListener('biscuits--product-selection', function(event){
          if (event.detail.active){
            let alreadySelectedItems = step.querySelectorAll('.biscuits-bundle-item.biscuits--active');
            alreadySelectedItems.forEach(function(selectedItem){
              if (selectedItem != productItem){
                selectedItem.click();
              }
            });
          }
        });
      });
    });
  }

  function linkConditionalProducts(relatedSteps) {
    if (!relatedSteps){
      return;
    }

    relatedSteps.forEach(function(relatedGroup){
      let parentStep = document.querySelector('[data-biscuits-step="'+ relatedGroup.parentStep+'"');
      let childStep = document.querySelector('[data-biscuits-step="'+ relatedGroup.childStep+'"');

      if (parentStep.dataset.biscuitsSelection != 's' /*|| childStep.dataset.biscuitsSelection != 's'*/){
        return;
      }

      let productItems = parentStep.querySelectorAll('.biscuits-bundle-item');

      if (!productItems){
        return;
      }

      // Helper function to apply conditions based on selected product's pack size
      function applyConditions(selectedProductItem) {
        // Get the pack size from the selected parent product
        let parentPackSize = getPackSizeFromProduct(selectedProductItem);

        // Get all product items in the child step
        let allChildItems = childStep.querySelectorAll('.biscuits-bundle-item-card');

        allChildItems.forEach(function(childItem){
          let childProduct = childItem.querySelector('.biscuits-bundle-item');
          let addOnPackSize = getPackSizeFromProduct(childProduct);

          // Show if: add-on pack size matches parent pack size, OR add-on pack size is empty/blank
          let isAllowed = !addOnPackSize || addOnPackSize === parentPackSize;

          if (!isAllowed){
            // Disable items that don't match
            if (childItem.classList.contains('biscuits--active')){
              childItem.click();
            }
            childItem.classList.add('biscuits--disabled');
          } else {
            // Enable items that match or have no pack size specified
            childItem.classList.remove('biscuits--disabled');
          }
        });

        // Update the swiper after modifying child step items
        let childSwiper = childStep.querySelector('.swiper');
        if (childSwiper && childSwiper.swiper) {
          childSwiper.swiper.update();
        }
      }

      // Check for preselected product on page load
      let preselectedItem = parentStep.querySelector('.biscuits-bundle-item[data-biscuits-preselected]');
      if (preselectedItem) {
        applyConditions(preselectedItem);
      }

      // Add event listeners for future selections
      productItems.forEach(function(productItem){
        productItem.addEventListener('biscuits--product-selection', function(event){
          if (!event.detail.active){
            return;
          }
          applyConditions(productItem);
        });
      });
    }); 
  }
  // END PRC 12.2025: Add-On Selection Based on Selected Pack

  function initDynamicMacoLink() {
    const macoLink = document.querySelector('[data-dynamic-maco-link]');
    const packStep =
      document.querySelector('[data-biscuits-step="1"]') || document.querySelector('#biscuits-step--1');

    if (!macoLink || !packStep) return;

    const linkTemplate = macoLink.dataset.macoLinkTemplate || macoLink.getAttribute('href');
    const storefrontSlug = macoLink.dataset.macoStorefrontSlug || 'main';
    const productItems = packStep.querySelectorAll('.biscuits-bundle-item');

    function buildMacoUrl(productItem) {
      const handle = productItem?.dataset?.biscuitsHandle || '';
      const productId =
        productItem?.dataset?.biscuitsProductId ||
        productItem?.productId ||
        productItem?.closest('[data-biscuits-card-id]')?.dataset?.biscuitsCardId ||
        '';
      const variantId =
        productItem?.selectedVariantId ||
        productItem?.dataset?.biscuitsSelectedVariantId ||
        productItem?.dataset?.biscuitsVariantId ||
        '';

      if (!handle && !productId && !variantId) return linkTemplate;

      let macoUrl = linkTemplate
        .replaceAll('{handle}', handle)
        .replaceAll('{pid}', productId)
        .replaceAll('{vid}', variantId)
        .replaceAll('{product_id}', productId)
        .replaceAll('{variant_id}', variantId);

      if (macoUrl !== linkTemplate || !productId) return macoUrl;

      const url = new URL(macoUrl, window.location.origin);
      const pathname = url.pathname.replace(/\/$/, '');
      url.pathname = pathname.endsWith('/permalink') ? pathname : `${pathname}/permalink`;
      url.searchParams.set('pid', productId);
      if (variantId) {
        url.searchParams.set('vid', variantId);
      } else {
        url.searchParams.delete('vid');
      }
      url.searchParams.set('storefront', storefrontSlug);

      return url.toString();
    }

    function updateMacoLink(productItem) {
      macoLink.href = buildMacoUrl(productItem);
    }

    function getSelectedProductItem() {
      return (
        packStep.querySelector('.biscuits-bundle-item.biscuits--active') ||
        packStep.querySelector('.biscuits-bundle-item[data-biscuits-preselected]')
      );
    }

    const selectedProductItem = getSelectedProductItem();

    if (selectedProductItem) {
      updateMacoLink(selectedProductItem);
    }

    productItems.forEach((productItem) => {
      productItem.addEventListener('biscuits--product-selection', (event) => {
        if (!event.detail.active) return;

        updateMacoLink(productItem);
      });
    });

    packStep.addEventListener('biscuits--step-update', () => {
      const selectedProductItem = getSelectedProductItem();

      if (selectedProductItem) {
        updateMacoLink(selectedProductItem);
      }
    });
  }

  function addOnGTMEventHandler(bundleStep) {
    // This function handles the GTM event for add-on inputs
    // It will be called when an add-on input is changed
    const items = bundleStep.querySelectorAll('.biscuits-bundle-item');
    items.forEach((item) => {
      item.addEventListener('biscuits--product-selection', (event) => {
        const item = event?.currentTarget;
        const productTitle = item?.productTitle;
        const selectedVariantId = item?.selectedVariantId;
        const checkBox = item?.checkbox;
        const isSelected = checkBox?.checked;
        if (!isSelected) return;
        const eventObject = {
          event: 'PDP Add On',
          selectedVariantId,
          productTitle,
        };
        window?.dataLayer?.push(eventObject);
      });
    });
  }

  // PRC 09.2026 (PDP redesign), reordered 10/16 at the PDP demo: the order
  // under Add to cart is Complete Your Gift (the add-on steps appended above)
  // -> trust bar -> Ship to multiple addresses. The trust bar is its own
  // main-product block and the ship link lives inside the buttons, so both
  // are moved here, after the add-ons are in place. Without this script the
  // blocks keep their template order, which still reads correctly.
  function arrangePdpActionArea() {
    if (!productForm) return;
    const buttons = productForm.querySelector('.product-form__buttons');
    const trust = document.querySelector('[data-bbym-pdp-trust]');
    if (trust) productForm.appendChild(trust);
    const macoLink = buttons?.querySelector('.maco-link-wrapper');
    if (macoLink && trust) productForm.appendChild(macoLink);
  }

  function appendAddonsToProductForm() {
    if (bundleStepCategories?.addOns?.length === 0 || !productForm) return;
    bundleStepCategories.addOns.forEach((step) => {
      addOnGTMEventHandler(step);
      productForm.appendChild(step);
    });
  }

  function categorizeBundleSteps() {
    // This categorizes the bundle steps into three categories:
    // 1. includesGiftBox: steps that are required and have a preselected product
    // 2. assortments: steps that are required but do not have a preselected product that is required (aka the category above)
    // 3. addOns: steps that are not required
    // 4. gridItems: steps that are required and have a selectionType of 'm' (PYF Grid Upcharge)

    if (!bundleSteps) return;
    const categories = {
      includesGiftBox: [],
      assortments: [],
      addOns: [],
      gridItems: [],
    };
    bundleSteps.forEach((step) => {
      if (
        step.required === true &&
        Array.from(step).some((product) => product.preselected === true && product.required === true)
      ) {
        categories.includesGiftBox.push(step);
      } else if (step.required === true && step.stepRules?.selection_type === 'm') {
        categories.gridItems.push(step);
      } else if (step.required === true) {
        categories.assortments.push(step);
      } else {
        categories.addOns.push(step);
      }
    });

    return categories;
  }

  function handlePriceUpdates() {
    // Sets up the logic for updating the price in the submit button
    // and the prices of the assortment products
    // will execute when the page loads and when the user updates the bundle
    // ensure this evokes on initial load and on every step update
    updatePriceinSubmitButton();
    updateAssortmentProductPrices();
    updateGridItemProductPrices();
    bundleSteps.forEach((step) => {
      step.addEventListener('biscuits--step-update', (event) => {
        updatePriceinSubmitButton();
        updateAssortmentProductPrices();
        updateGridItemProductPrices();
      });
    });
  }

  function updatePriceinSubmitButton() {
    if (bundleForm && addToCartTextSpan) {
      const subtotal = bundleForm.formTotalPrice / 100;
      const formattedPrice = subtotal.toLocaleString('en-US', {
        style: 'currency',
        currency: 'USD',
      });

      // NOTE: when nothing is selected, the add to cart button is disabled and the price is hidden with CSS
      addToCartPriceSpan.innerHTML = `${formattedPrice} | `;
      addToCartTextSpan.insertAdjacentElement('beforebegin', addToCartPriceSpan);
    }
  }

  function prependStartingAtTextToPrice() {
    if (!bundleStepCategories) return;
    const assortmentSteps = bundleStepCategories?.assortments;
    if (!assortmentSteps || assortmentSteps?.length === 0) return;
    const productPriceEl = document.querySelector('product-info .price');
    if (!productPriceEl?.innerHTML) return;

    let allPricesEqual = true;

    assortmentSteps.forEach((step) => {
      const productsArray = Array.from(step?.products);
      if (!productsArray) return;
      // Compare the price of every product to determine if all prices are the same
      const basePrice = productsArray[0]?.priceElement?.price;
      allPricesEqual = productsArray.every((product) => {
        return product?.priceElement?.price === basePrice;
      });
    });

    // If all prices are equal, do not prepend the text
    if (allPricesEqual) return;

    // prepend the text "starting at: " to the price
    const priceText = productPriceEl.innerHTML;
    productPriceEl.innerHTML = 'Starting at: ' + priceText;
  }

  function updateAssortmentProductPrices() {
    if (!bundleStepCategories) return;
    const assortmentSteps = bundleStepCategories?.assortments;
    if (!assortmentSteps || assortmentSteps?.length === 0) return;

    assortmentSteps.forEach((step) => {
      const productsArray = Array.from(step?.products);
      if (!productsArray) return;
      const basePriceEl = productsArray.reduce((prev, curr) => {
        return prev?.priceElement?.base_price < curr?.priceElement?.base_price ? prev : curr;
      }, productsArray[0]);
      const basePrice = basePriceEl?.priceElement?.base_price / 100;

      Array.from(step?.products)?.forEach((product) => {
        const priceEl = product.priceElement;
        const assortmentPrice = priceEl.base_price / 100;
        if (assortmentPrice > basePrice) {
          const diff = assortmentPrice - basePrice;
          const formattedPrice = diff.toLocaleString('en-US', {
            style: 'currency',
            currency: 'USD',
          });

          // If the price is greater than the base price, show the difference
          priceEl.innerHTML = '+' + formattedPrice;
        } else {
          // If the price is less than or equal to the base price, don't show anything
          priceEl.innerHTML = '';
        }
      });
    });
  }

  function updateGridItemProductPrices() {
    if (!bundleStepCategories) return;
    const gridItemStep = bundleStepCategories?.gridItems;
    if (!gridItemStep || gridItemStep?.length === 0) return;

    gridItemStep.forEach((step) => {
      const productsArray = Array.from(step?.products);
      if (!productsArray) return;
      const basePriceEl = productsArray.reduce((prev, curr) => {
        return prev?.priceElement?.base_price < curr?.priceElement?.base_price ? prev : curr;
      }, productsArray[0]);
      const basePrice = basePriceEl?.priceElement?.base_price / 100;

      Array.from(step?.products)?.forEach((product) => {
        const priceEl = product.priceElement;
        const assortmentPrice = priceEl.base_price / 100;
        if (assortmentPrice >= basePrice) {
          const formattedPrice = assortmentPrice.toLocaleString('en-US', {
            style: 'currency',
            currency: 'USD',
          });

          // If the price is greater than the base price, show the difference
          priceEl.innerHTML = '+' + formattedPrice;
        } else {
          // If the price is less than or equal to the base price, don't show anything
          priceEl.innerHTML = '';
        }
      });
    });
  }
});
